import React, { useCallback, useState } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import LookupForm from './LookupForm';
import OtpVerification from '../OtpVerification';

export interface FormValues {
  mobilePhone: string;
  ssn: string;
  zip: string;
}

export type PropTypes = RouteComponentProps & {
  onOtpSuccessful: (values: {
    ssn: string;
    zip: string;
    mobilePhone: string;
    otpCode: string;
  }) => Promise<void>;
};

const PhoneLookup: React.FC<PropTypes> = props => {
  const { onOtpSuccessful, match } = props;

  const [values, setValues] = useState<FormValues>({
    mobilePhone: '',
    ssn: '',
    zip: '',
  });

  const handleOtpSuccess = useCallback(
    async (otpCode: string) => {
      await onOtpSuccessful({
        ssn: values.ssn,
        zip: values.zip,
        mobilePhone: values.mobilePhone,
        otpCode,
      });
    },
    [values, onOtpSuccessful],
  );

  return (
    <Switch>
      <Route
        path={`${match.path}`}
        exact
        render={routeProps => (
          <LookupForm {...routeProps} onSubmit={setValues} />
        )}
      />
      <Route
        path={`${match.path}/otp-verification`.replace('//', '/')}
        render={routeProps => (
          <OtpVerification
            {...routeProps}
            onOtpSuccessful={handleOtpSuccess}
            values={values}
          />
        )}
      />
    </Switch>
  );
};

export default PhoneLookup;
